var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy-customer-short inline-flex align-items-center",class:{ small: _vm.small }},[_c('div',{staticClass:"customer",class:{ blurry: _vm.isBlurred }},[_vm._v(_vm._s(_vm.customerName))])])}
var staticRenderFns = []

export { render, staticRenderFns }